import * as api from '@/api/user'
import User from '@/store/models/user'

export let state = {
  user: new User,
  admins: {
    data: []
  },
  tenants: {
    data: []
  },
  customers: {
    data: []
  },
  bookings: {
    data: []
  },
  deposits: {
    data: []
  }
}

export let mutations = {
  setAdmins: (state, payload) => state.admins = payload,
  setTenants: (state, payload) => state.tenants = payload,
  setCustomers: (state, payload) => state.customers = payload,
  setBookings: (state, payload) => state.bookings = payload,
  setDeposits: (state, payload) => state.deposits = payload,

  reset: state => state.user = new User,
  setUser: (state, payload) => state.user = (new User).hydrate(payload),
  setName: (state, payload) => state.user.name = payload,
  setLastName: (state, payload) => state.user.last_name = payload,
  setEmail: (state, payload) => state.user.email = payload,
  setPassword: (state, payload) => state.user.password = payload,
  setPasswordConfirmation: (state, payload) => state.user.password_confirmation = payload,
  setActive: (state, payload) => state.user.active = payload,
  setMobile: (state, payload) => state.user.profile.mobile = payload,
  setLandline: (state, payload) => state.user.profile.landline = payload,
  setCompanyName: (state, payload) => state.user.profile.company_name = payload,
  setVatNumber: (state, payload) => state.user.profile.vat_number = payload,
  setRegNumber: (state, payload) => state.user.profile.company_reg_number = payload,
  setBuilding: (state, payload) => state.user.address.building = payload,
  setStreet: (state, payload) => state.user.address.street = payload,
  setSuburb: (state, payload) => state.user.address.suburb = payload,
  setCity: (state, payload) => state.user.address.city = payload,
  setPostCode: (state, payload) => state.user.address.post_code = payload,
  setProvince: (state, payload) => state.user.address.province = payload,
  setBankName: (state, payload) => state.user.bank_detail.bank_name = payload,
  setBranchCode: (state, payload) => state.user.bank_detail.branch_code = payload,
  setBankAccountName: (state, payload) => state.user.bank_detail.account_name = payload,
  setBankAccountType: (state, payload) => state.user.bank_detail.account_type = payload,
  setBankAccountNumber: (state, payload) => state.user.bank_detail.account_number = payload,
  setSwiftCode: (state, payload) => state.user.bank_detail.swift_code = payload,

  // Admin Notifications
  setAdminNotifications: (state, payload) => state.user.admin_notification.admin = payload,
  setLibraryNotifications: (state, payload) => state.user.admin_notification.library = payload,
}

export let actions = {

  paginateAdmins: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginateAdmins(path, response => {
      commit('setAdmins', response.data)
      resolve()
    }, reject)
  }),

  paginateTenants: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginateTenants(path, response => {
      commit('setTenants', response.data)
      resolve()
    }, reject)
  }),

  paginateCustomers: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginateCustomers(path, response => {
      commit('setCustomers', response.data)
      resolve()
    }, reject)
  }),

  paginateBookings: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginateBookings(path, response => {
      commit('setBookings', response.data)
      resolve()
    }, reject)
  }),

  paginateDeposits: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginateDeposits(path, response => {
      commit('setDeposits', response.data)
      resolve()
    }, reject)
  }),

  createAdmin: ({ state, commit }) => new Promise((resolve, reject) => {
    api.createAdmin(state.user, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  createTenant: ({ state, commit }) => new Promise((resolve, reject) => {
    api.createTenant(state.user, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  loadAdmin: ({ commit }, user) => new Promise((resolve, reject) => {
    api.loadAdmin(user, response => {
      commit('setUser', response.data)
      resolve()
    }, reject)
  }),

  updateAdmin: ({ state }) => new Promise((resolve, reject) => {
    api.updateAdmin(state.user, () => {
      resolve()
    }, reject)
  }),

  load: ({ commit }, user) => new Promise((resolve, reject) => {
    api.load(user, response => {
      commit('setUser', response.data)
      resolve()
    }, reject)
  }),

  approve: ({ state }) => new Promise((resolve, reject) => {
    api.approve(state.user, () => {
      resolve()
    }, reject)
  }),

  updateUser: ({ state }) => new Promise((resolve, reject) => {
    api.updateUser(state.user, resolve, reject)
  })

}

export let getters = {
  user: state => state.user
}